import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, resolveOnboardingPath } from "../contexts/AuthContext";
import LoadingScreen from "../ui/loadingScreen/LoadingScreen";

export default function ProtectedRoute() {
  const { auth, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen mainText="Cargando sesión..." />;
  if (!auth) return <Navigate to="/login" replace />;

  // El usuario está autenticado pero todavía no terminó el onboarding:
  // confinarlo al paso pendiente (no puede navegar la app hasta completarlo).
  const onboardingPath = resolveOnboardingPath(auth);
  if (onboardingPath && onboardingPath !== location.pathname) {
    return <Navigate to={onboardingPath} replace />;
  }

  return <Outlet />;
}
